import React from 'react';

import { pipe } from '@code-expert/prelude';
import { concatRoutes, parser } from '/imports/modules/Routing';
import { ltiErrorRoute } from '/imports/startup/shared/routes/lti';
import { Authorise, AuthorisePublic } from '/imports/ui/components/Authorise';
import { ltiConsumerRoute } from './routes';

const LtiError = React.lazy(() => import('/imports/ui/pages/lti/LtiError'));
const LtiTestConsumer = React.lazy(() => import('/imports/ui/pages/lti/LtiTestConsumer'));

export const ltiRouter = concatRoutes([
  pipe(
    ltiErrorRoute.parser,
    parser.map((props) => (
      <AuthorisePublic deny={['exam']}>
        <LtiError {...props} />
      </AuthorisePublic>
    )),
  ),
  pipe(
    ltiConsumerRoute.parser,
    parser.map(() => (
      <Authorise allow={['admin']}>
        <LtiTestConsumer />
      </Authorise>
    )),
  ),
]);
